import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getData } from "../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../interfaces/response";

export interface ILockReason {
  id: number;
  lockReasonType: number;
  reason: string;
  requiresAdditionalInfo: boolean;
}

const getLockReasons = async (): Promise<IResponse<ILockReason[]>> => {
  const response = await getData(ajaxEndpoints.LOCK_REASONS);

  return response.data;
};

export default function useGetLockReasons() {
  return useQuery<IResponse<ILockReason[]>, Error>(
    ["getLockReasons"],
    getLockReasons,
    {
      refetchOnWindowFocus: false,
    },
  );
}
